import React, { useState, useEffect } from 'react';

const EditEmailModal = ({ show, user, onClose, onSave }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) {
      setEmail(user.email);
      setError('');
    }
  }, [user]);

  if (!show) return null;

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setError('Email is required');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    onSave(email);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg max-w-md w-full p-6">
        <h2 className="text-2xl font-bold text-white mb-6">
          Edit User Email
        </h2>

        <form onSubmit={handleSubmit}>
          {/* User Info */}
          <div className="mb-4 p-4 bg-gray-700 rounded">
            <div className="mb-2">
              <span className="text-gray-400 text-sm">Username:</span>
              <p className="text-white font-medium">{user?.username}</p>
            </div>
            <div className="mb-2">
              <span className="text-gray-400 text-sm">Current Email:</span>
              <p className="text-white">{user?.email}</p>
              {user?.email.endsWith('@verbalwarzone.com') && (
                <p className="text-yellow-400 text-xs mt-1">⚠️ Auto-generated email from YouTube import</p>
              )}
            </div>
            <div>
              <span className="text-gray-400 text-sm">Role:</span>
              <p className="text-white capitalize">{user?.role}</p>
            </div>
          </div>

          {/* Email Input */}
          <div className="mb-6">
            <label className="block text-white mb-2 font-medium">
              New Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              className="w-full p-3 bg-gray-700 text-white rounded border border-gray-600 focus:border-blue-500 focus:outline-none"
              placeholder="artist@example.com"
              required
            />
            {error && (
              <p className="text-red-400 text-sm mt-2">{error}</p>
            )}

            <div className="mt-3 p-3 bg-gray-900 rounded text-sm">
              <p className="text-gray-300">
                <strong>Note:</strong> Changing the email will update the user's login email.
                Make sure the user has access to the new email address.
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
            >
              Save Email
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEmailModal;
